import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { AdSpacePhotoCommentInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  commentToUpdate: AdSpacePhotoCommentInterface | null;
  setCommentToUpdate: React.Dispatch<React.SetStateAction<AdSpacePhotoCommentInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const AdSpacePhotoCommentsUpdateDialog: React.FC<Props> = ({
  open,
  commentToUpdate,
  setCommentToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Ad Space Photo Comment</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Ad Space Photo ID"
        type="number"
        value={commentToUpdate?.adSpacePhotoId ?? ''}
        onChange={e => setCommentToUpdate(p => p ? { ...p, adSpacePhotoId: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Comment"
        value={commentToUpdate?.comment ?? ''}
        onChange={e => setCommentToUpdate(p => p ? { ...p, comment: e.target.value } : p)}
        fullWidth
        margin="dense"
        required
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={commentToUpdate?.active !== undefined ? (commentToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setCommentToUpdate(p => p ? { ...p, active: e.target.value === 'yes' } : p)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);